import { get } from "lodash";
import { MdClose } from "react-icons/md";
import { DATE_FORMAT, RELATIONSHIP } from "utils/constants";
import Button from "../../../../Comparison/Amellis/Components/Button";
import Input from "../../../../Comparison/Amellis/Components/Input";
import { buildMappedProduct } from "../../mappedProduct";
import ProductCard from "./ProductCard";
const RelatedPerson = ({
  title,
  relatedPerson,
  onDelete,
  TRANSLATION,
  products,
  selectedProducts,
  setSelectedProducts,
  disabledDate,
  defaultPickerValue,
  inputProps,
  relationship,
}) => {
  const getCostForBeneficiary = (product, contactId) => {
    const costDetails = get(product, "costDetails");
    const currency = get(product, "currency", "EUR");

    if (!costDetails) return null;

    if (relationship === RELATIONSHIP.SPOUSE) {
      return { cost: get(costDetails, "spouseCost"), currency };
    } else if (relationship === RELATIONSHIP.CHILD) {
      const childCost = get(costDetails, contactId);
      if (childCost) {
        return { cost: childCost, currency };
      }
      return null;
    }
    return null;
  };
  return (
    <div className="relatedPersons__content">
      <div className="relatedPersons__content--header">
        <span className="relatedPersons__content--header__title">{title}</span>
        <Button size="medium" type={"danger-light"} onClick={onDelete}>
          <MdClose size={20} />
          Retirer
        </Button>
      </div>
      <div className="relatedPersons__content--form">
        <Input
          type="date"
          label={TRANSLATION.BIRTH_DATE.LABEL}
          placeholder={"JJ / MM / AAAA"}
          format={DATE_FORMAT}
          showToday={false}
          defaultPickerValue={defaultPickerValue}
          disabledDate={disabledDate}
          {...inputProps}
        />
      </div>
      <div className="relatedPersons__content--products">
        {products.map((product, i) => {
          const insurancePlan = get(product, "insurancePlan");
          const beneficiaryCost = getCostForBeneficiary(
            product,
            get(relatedPerson, "id"),
          );
          return (
            <ProductCard
              key={`product.insurancePlan.${i}`}
              isSelected={
                selectedProducts[get(relatedPerson, "identity.id")]?.id ===
                get(insurancePlan, "id")
              }
              selectProduct={() =>
                setSelectedProducts((prev) => ({
                  ...prev,
                  [get(relatedPerson, "identity.id")]:
                    buildMappedProduct(insurancePlan),
                }))
              }
              id={get(insurancePlan, "id")}
              name={get(insurancePlan, "name")}
              alias={get(insurancePlan, "alias")}
              costDetails={
                beneficiaryCost
                  ? { beneficiaryCost: beneficiaryCost.cost }
                  : null
              }
              currency={beneficiaryCost?.currency}
            />
          );
        })}
      </div>
    </div>
  );
};

export default RelatedPerson;
